import React,{useState} from 'react';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import useStyles from './Styles';
import {Tools} from './Tools';
import noImage from './imgs/noimage.png';
import noImageThumb from './imgs/noimage_thumb.png';


interface Props {
    owner_id: number,
    img_id: number,
    name?: string,
    secret?: string,
    thumb: boolean,
    zoomIconOff?: boolean,
    className?: "imgItemLarge" | "imgItemPhoto" | "imgList" | "imgProfile" | "imgProfileHeader" | "imgProfilePhoto" | "imgItemThumb" | "imgItemThumbSmall" | "imgBookList" | "imgContain",
}

const StoreImg:React.FC<Props> = (props)=> {
    const classes = useStyles();
    const [open, setOpen] = useState(false);

    // if(!props.img_id){
    //     return (null);
    // }
    //if( props.owner_id===0 || props.img_id===0 ){
    if( props.owner_id===0 ){
        return (null);
    }

    let name = "画像";
    if( props.name ){
        name = props.name;
    }

    let classname = "";
    if( props.className ){
        classname = classes[ props.className ];
    } else {
        classname = classes.img;
    }

    let src;
    //console.log("img_id",props.img_id);
    if( !props.img_id || props.img_id===0 ){
        if( props.thumb ){
            src = noImageThumb;
        } else {
            src = noImage;
        }
        return (
            <img src={src} title={name} alt={name} className={classname}/>
        );

    } else if( props.secret && props.secret!==""){
        src = Tools.getStoreSecretImg(props.owner_id,props.img_id,props.secret,props.thumb);
    } else {
        src = Tools.getStoreImg(props.owner_id,props.img_id,props.thumb);
    }

    if( !props.thumb ){
        return (
            <img src={src} title={name} alt={name} className={classname}/>
        );
    }

    let srcZoom;
    if( props.secret && props.secret!==""){
        srcZoom = Tools.getStoreSecretImg(props.owner_id,props.img_id,props.secret,false);
    } else {
        srcZoom = Tools.getStoreImg(props.owner_id,props.img_id,false);
    }

	// return (
    //     <a href={srcZoom} target="_blank" rel="noopener noreferrer"><img src={src} title={name} alt={name} className={classname}/></a>
    // );

    return (
        <>
            <div style={{ position: 'relative' }} className={classname}>
                <img
                    src={src}
                    title={name}
                    alt={name}
                    style={{
                        cursor: 'pointer',
                        borderRadius:'4px',
                        display: 'block',
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                    }}
                    onClick={() => setOpen(true)}
                />
                {!props.zoomIconOff && (
                <div
                    style={{position:'absolute',bottom:'0',left:'0',backgroundColor:'gray',borderRight:"2px solid white",borderTop:"2px solid white",width:'1.5em',height:'1.5em',borderRadius:'0 0.5em 0 0'}}
                >
                    <ZoomInIcon
                        style={{color:'white',fontSize:'1.5em',cursor:'pointer'}}
                        onClick={() => setOpen(true)}
                    />
                </div>
                )}
            </div>
            {open && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        background: 'rgba(0,0,0,0.7)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                    }}
                    onClick={() => setOpen(false)}
                >
                    <img
                        src={srcZoom}
                        alt={name}
                        style={{
                            maxWidth: '90vw',
                            maxHeight: '90vh',
                            boxShadow: '0 0 16px #000',
                            background: '#fff',
                            borderRadius: '4px',
                        }}
                        onClick={e => e.stopPropagation()}
                    />
                </div>
            )}
        </>
    );
}

export default StoreImg;
